import { render, staticRenderFns } from "./KirmiziSantralCDR.vue?vue&type=template&id=3b43c0ac&scoped=true"
import script from "./KirmiziSantralCDR.vue?vue&type=script&lang=js"
export * from "./KirmiziSantralCDR.vue?vue&type=script&lang=js"
import style0 from "./KirmiziSantralCDR.vue?vue&type=style&index=0&id=3b43c0ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b43c0ac",
  null
  
)

export default component.exports